import { BasketItem, basketItemFromResponse } from './BasketItem';
import { OfferSummary, offerSummaryFromResponse } from '../Offer/OfferSummary';
import {
  ProductSummary,
  productSummaryFromResponse,
} from '../Product/ProductSummary';

export interface BasketSummary {
  items: BasketItem[];
  atCheckoutDiscountProducts: ProductSummary[];
  eligibleFreeProducts: ProductSummary[];
  isBasketChange: boolean;
  freeShippingAmountMap: Record<string, number>;
  canUsePointSystem: boolean;
  pointValue: number;
  pointMinValue: number;
  minPointUsageValue: number;
  offerSummary?: OfferSummary;
}

export const basketSummaryFromResponse = (
  responseData: any,
): BasketSummary => ({
  items: responseData.basket.map(basketItemFromResponse),
  atCheckoutDiscountProducts: (
    responseData.at_checkout_discount_products ?? []
  ).map(productSummaryFromResponse),
  eligibleFreeProducts: (responseData.eligible_free_products ?? []).map(
    productSummaryFromResponse,
  ),
  isBasketChange: responseData.is_basket_change,
  freeShippingAmountMap: responseData.free_shipping_amount_map,
  canUsePointSystem: responseData.can_use_point_system,
  pointValue: responseData.point_value,
  pointMinValue: responseData.point_min_value,
  minPointUsageValue: responseData.min_point_usage_value,
  offerSummary: responseData.offer_summary
    ? offerSummaryFromResponse(responseData.offer_summary)
    : undefined,
});
